<template>
  <div class="cus-chat-view">
    <div class="cus-chat-view-search">
      <el-radio-group
        v-model="radio"
        size="small"
        style="margin-right: 10px"
        @change="selectSearchType"
        :disabled="!isRequestSuccess"
      >
        <el-radio-button label="今日"></el-radio-button>
        <el-radio-button label="昨日"></el-radio-button>
        <el-radio-button label="近7日"></el-radio-button>
        <el-radio-button label="近30日"></el-radio-button>
      </el-radio-group>
      <el-date-picker
        size="small"
        v-model="searchDate"
        type="daterange"
        :editable="false"
        @change="selectDate"
        value-format="yyyy-MM-dd"
        range-separator="~"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width:240px;margin-right: 10px;padding: 2px 10px;"
        :disabled="!isRequestSuccess"
      >
      </el-date-picker>
      <!-- <el-button size="small" type="primary" @click="reset" :disabled="!isRequestSuccess">重置</el-button> -->
    </div>
    <div class="below">
      <div class="l-nav">
        <div
          style=" font-size: 15px; text-align:center;font-weight: bold;padding: 18px;border-bottom: 1px solid #e6e6e6"
        >
          服务职员
        </div>
        <el-scrollbar class="name-list common-class">
          <div class="masking" v-show="!isRequestSuccess"></div>
          <el-aside class="chat-type common-class">
            <el-table
              v-loading="loading"
              highlight-current-row
              :data="dataNew"
              @row-click="select"
              :show-header="false"
              :row-style="{ height: '65px' }"
            >
              <el-table-column prop="name" label=""> </el-table-column>
              <el-table-column align="center" prop="dateStr" label="">
                <template slot-scope="scope">
                  {{ scope.row.dateStr }}
                </template>
              </el-table-column>
            </el-table>
            <!-- <el-pagination v-if="dataParam.total > 8" small @current-change="handleCurrentChange"
              :current-page.sync="dataParam.current" :page-size="dataParam.size" layout="prev, pager, next"
              :total="dataParam.total" style="text-align:center;
                padding-top:10px;">
            </el-pagination> -->
          </el-aside>
        </el-scrollbar>
      </div>
      <div style="flex: 8;">
        <ChatType
          v-bind:idData="idSet"
          :chatType="'customer'"
          @requestSuccess="requestSuccess"
        />
      </div>
    </div>
  </div>
</template>
<script>
import ChatType from "./ChatType";
import { getCustomerStaffList } from "@/api/customer/customer.js";
export default {
  name: "ChatContentDia",
  props: {
    idData: {
      type: String,
      default: "",
      required: true,
    },
  },
  components: {
    ChatType,
  },
  data() {
    return {
      dataParam: {
        sendFrom: this.uid,
        startTime: "",
        endTime: "",
        current: 1,
        size: 8,
        total: 0,
        name: "",
      },
      searchDate: [],
      startTime: "2021-01-01",
      endTime: "",
      startTimeDefault: "2021-01-01",
      endTimeDefault: "",
      current: 1,
      size: 100,
      loading: false,
      uid: this.idData,
      cid: "",
      idSet: [],
      radio: "近7日",
      inputName: "",
      msgSort: "all",
      dataFirst: [],
      dataNew: [],
      list: JSON.parse(localStorage.getItem("routerList")),
      myDepartment: JSON.parse(localStorage.getItem("myDepartment")),
      flatList: [],
      ISH: false,
      ISO: false,
      /** 请求是否完成 */
      isRequestSuccess: true,
      /** 提示实例，防止弹出多个提示 */
      messageInstance: null,
    };
  },
  computed: {
    btnAuthority() {
      return this.$store.state.tagsView.roleAuthrority;
    },
  },
  methods: {
    select(val) {
      // this.handleLimits();
      console.log(val);
      console.log(
        "该员工的权限设置 myDepartment ",
        this.myDepartment,
        val.departmentId
      );
      if (this.ISH && this.myDepartment == val.departmentId) {
        this.cid = val.uid;
        this.idSet = [this.uid, this.cid];
      } else if (this.ISO && this.myDepartment != val.departmentId) {
        this.cid = val.uid;
        this.idSet = [this.uid, this.cid];
      } else if (this.ISO && this.ISH) {
        this.cid = val.uid;
        this.idSet = [this.uid, this.cid];
      } else {
        this.$message.warning("暂无权限查看聊天记录");
      }
    },
    handleDisable(data) {
      console.log("查看记录权限", data);
    },
    handleLimits() {
      this.handleFlat(this.$store.state.tagsView.routerList);
      this.flatList.forEach((item) => {
        if (item.menuId == "85") {
          this.ISH = true;
        }
        if (item.menuId == "86") {
          this.ISO = true;
        }
      });
    },

    // 扁平化数组
    handleFlat(list) {
      list.forEach((item) => {
        if (item.menus.length <= 0) {
          this.flatList.push({ menuName: item.menuName, menuId: item.menuId });
        } else {
          this.handleFlat(item.menus);
        }
      });
    },

    // 获取今天时间
    getToday() {
      var date = new Date();
      var y = date.getFullYear();
      var m =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return y + "-" + m + "-" + d;
    },

    // 获取明昨天的时间
    getYesterday() {
      var date = new Date();
      date = new Date(date - 1000 * 60 * 60 * 24);
      var y = date.getFullYear();
      var m =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return y + "-" + m + "-" + d;
    },

    /** 获取新版客户对应员工的聊天列表 */
    getContactList(sendFrom, startTime, endTime, current, size) {
      this.loading = true;
      this.isRequestSuccess = !this.loading;
      getCustomerStaffList(
        sendFrom,
        startTime,
        endTime,
        current,
        size,
        localStorage.getItem("Authorization"),
        true
      )
        .then((res) => {
          if (res && res.error && res.error.code === 200) {
            this.dataFirst = this.dataNew = res.data;
            this.dataParam.total = res.data.length;
          } else {
            if (this.messageInstance) this.messageInstance.close();
            this.messageInstance = this.$message.error("获取失败，请稍后再试");
          }
          this.loading = false;
          this.isRequestSuccess = !this.loading;
        })
        .catch((err) => {
          if (this.messageInstance) this.messageInstance.close();
          this.messageInstance = this.$message.error("获取失败，请稍后再试");
          this.loading = false;
          this.isRequestSuccess = !this.loading;
          console.log("err++++", err);
        });
    },

    // 时间变化触发函数
    selectDate() {
      this.idSet = [];
      this.current = 1;
      if (this.searchDate != null) {
        this.startTime = this.searchDate[0];
        this.endTime = this.searchDate[1];
        this.radio = "选择日期";
      } else {
        this.startTime = this.startTimeDefault;
        this.endTime = this.getToday();
        this.radio = "";
      }
      this.getContactList(
        this.uid,
        this.startTime,
        this.endTime,
        this.current,
        this.size
      );
    },

    searchName(keywords) {
      return this.dataFirst.filter((item) => {
        if (item.name.includes(keywords)) {
          return item;
        }
      });
    },

    displayLength(str, length) {
      var displayLength = 0;
      for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) <= 40869 && str.charCodeAt(i) >= 19968) {
          displayLength++;
        }
        displayLength++;
      }
      displayLength = length - displayLength + str.length;

      return displayLength;
    },

    isYesterday(time) {
      var today = new Date();
      var yesterday = new Date(today - 1000 * 60 * 60 * 24);
      var test = new Date(time);
      if (
        yesterday.getYear() === test.getYear() &&
        yesterday.getMonth() === test.getMonth() &&
        yesterday.getDate() === test.getDate()
      ) {
        return true;
      } else {
        return false;
      }
    },

    displayTimeStr(timeStr) {
      var day = new Date(timeStr).getDay();
      var time = new Date(timeStr).getTime();
      var timeNow = Date.parse(new Date());

      var timeDiffer = timeNow - time;
      if (timeDiffer <= 60000) {
        //一分钟内
        var returnTime = "刚刚";
      } else if (
        timeDiffer > 60000 &&
        timeDiffer < 86400000 &&
        this.isYesterday(time) === false
      ) {
        //今日
        var returnTime = "今天";
      } else if (timeDiffer > 60000 && this.isYesterday(time) === true) {
        //昨天
        var returnTime = "昨天";
      } else if (timeDiffer >= 86400000 && timeDiffer < 60000 * 60 * 24 * 7) {
        var returnTime = "星期" + "日一二三四五六".charAt(day);
      } else var returnTime = timeStr;

      return returnTime;
    },

    /** 快捷选择改变 */
    selectSearchType() {
      this.idSet = [];
      this.searchDate = [];
      if (this.radio == "今日") {
        this.startTime = this.getToday();
        this.endTime = this.getToday();
        this.current = 1;
        // 重新获取好友
        this.getContactList(
          this.uid,
          this.startTime,
          this.endTime,
          this.current,
          this.size
        );
      } else if (this.radio == "昨日") {
        this.startTime = this.getYesterday();
        this.endTime = this.getYesterday();
        this.current = 1;
        // 重新获取好友
        this.getContactList(
          this.uid,
          this.startTime,
          this.endTime,
          this.current,
          this.size
        );
      } else if (this.radio == "近7日") {
        const [startDate, endDate] = this.getDateRange(7);
        this.startTime = startDate;
        this.endTime = endDate;
        this.current = 1;
        // 重新获取好友
        this.getContactList(
          this.uid,
          this.startTime,
          this.endTime,
          this.current,
          this.size
        );
      } else if (this.radio == "近30日") {
        const [startDate, endDate] = this.getDateRange(30);
        this.startTime = startDate;
        this.endTime = endDate;
        this.current = 1;
        // 重新获取好友
        this.getContactList(
          this.uid,
          this.startTime,
          this.endTime,
          this.current,
          this.size
        );
      }
    },

    /** 点击重置按钮触发 */
    reset() {
      this.searchDate = [];
      this.idSet = [];
      this.startTime = this.startTimeDefault;
      this.endTime = this.endTimeDefault;
      this.current = 1;
      this.radio = "";
      // 重新获取好友
      this.getContactList(
        this.uid,
        this.startTime,
        this.endTime,
        this.current,
        this.size
      );
    },

    // 点击当前分页
    handleCurrentChange(parm) {
      // this.getContactList(this.dataParam);
    },

    // 由子组件触发，请求完成触发，触发后在次通知父组件
    requestSuccess(val) {
      this.isRequestSuccess = val;
    },

    /** 获取从今天开始 */
    getDateRange(daysBefore) {
      // 获取当前日期（本地时区）
      const today = new Date();

      // 计算起始日期：今天减去(daysBefore-1)天（包含今天）
      const startDate = new Date(today);
      startDate.setDate(today.getDate() - (daysBefore - 1));

      // 日期格式化函数
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      return [formatDate(startDate), formatDate(today)];
    },
  },

  created() {
    const [startDate, endDate] = this.getDateRange(7);
    this.startTime = startDate;
    this.endTime = endDate;
    // this.endTime = this.endTimeDefault = this.getToday();
    this.getContactList(
      this.uid,
      this.startTime,
      this.endTime,
      this.current,
      this.size
    );
  },

  watch: {
    idData: {
      handler(newVal, oldVal) {
        this.idSet = [];
        this.inputName = "";
        this.uid = newVal;
        this.current = 1;
        this.getContactList(
          newVal,
          this.startTime,
          this.endTime,
          this.current,
          this.size
        );
      },
    },

    inputName: function(val) {
      if (val == "") {
        this.dataNew = this.dataFirst;
      } else {
        this.dataNew = this.searchName(val);
      }
    },

    btnAuthority: {
      handler(newVal, oldVal) {
        console.log("XXXXXXXX 聊天审计-客户列表", newVal);

        if (newVal.length > 0) {
          newVal.forEach((item) => {
            if (item.pname == "聊天审计-客户列表") {
              console.log("XXXXXXXX 聊天审计-客户列表", newVal);
              let senBtnAuthority = item.cfunBu;
              if (senBtnAuthority.indexOf("ltjlckkubbm") != -1) {
                // 可查看本部门
                this.ISH = true;
              } else {
                // this.senGroupOption = false
                this.ISH = false;
              }
              if (senBtnAuthority.indexOf("ltjlckkukbm") != -1) {
                // 可查看外部门
                this.ISO = true;
              } else {
                this.ISO = false;
              }
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.cus-chat-view {
  width: 100%;
  height: 100%;

  .cus-chat-view-search {
    margin-bottom: 10px;
  }

  .below {
    display: flex;
    justify-content: space-around;
    border: 1px solid #e6e6e6;
    width: 100%;
    height: 60vh;

    .l-nav {
      display: flex;
      flex-direction: column;
      width: 280px;
      border-right: 1px solid #e6e6e6;

      .common-class {
        width: 100% !important;
        height: 100% !important;
      }

      .name-list {
        // flex: 1;
        // overflow-y: scroll;
        .masking {
          width: 100%;
          height: 100%;
          background-color: #ccc;
          position: absolute;
          z-index: 9999;
          opacity: 0.3;
        }

        // /deep/ .el-scrollbar__view {
        //   width: 100% !important;
        //   height: 100% !important;
        // }

        // /deep/ .is-scrolling-none {
        //   width: 100% !important;
        //   height: 100% !important;
        // }

        // .chat-type {
        //   /deep/ .el-menu {
        //     border-right: 0 !important;
        //   }

        //   /deep/ .el-table--fit {
        //     width: 100% !important;
        //     height: 100% !important;
        //   }
      }

      // }
    }

    .category {
      width: 100%;

      /deep/.el-tabs__header {
        margin: 0 !important;

        .el-tabs__item.is-active {
          border-bottom: none !important;
        }

        .el-tabs__nav {
          border: none !important;
        }

        .el-tabs__item {
          border-left: none;
          border-right: 1px solid #e4e7ed;
        }
      }
    }
  }
}

::-webkit-scrollbar {
  width: 5px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(177, 181, 189, 0.5);
  border-radius: 5px;
}
</style>
